import * as React from "react";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutGridItem, UitkLayoutConditionalGridSpan, UitkLayoutGridItemProps } from "uitk-react-layout-grid";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { useLocalization } from "@shared-ui/localization-context";
import { gtConfig } from "src/stores/wizard/config/staticConfigs/car/gt/gtConfig";
import { liveAnnounce, Level } from "uitk-react-utils";

interface GroundTransportSwitchProps {
  onSwapTypeheadLocations: () => void;
  colSpan: UitkLayoutConditionalGridSpan;
}

interface GroundTransportSwitchClasses {
  iconName: string;
  class: string;
  justifySelf: UitkLayoutGridItemProps["justifySelf"];
}

export const GroundTransportSwitch: React.FunctionComponent<GroundTransportSwitchProps> = (props) => {
  const { onSwapTypeheadLocations, colSpan } = props;
  const { formatText } = useLocalization();
  const isMobile = colSpan.small;

  const mobileClasses: GroundTransportSwitchClasses = {
    iconName: "swap_vert",
    class: "mobileSwitch",
    justifySelf: "end",
  };

  const desktopClasses: GroundTransportSwitchClasses = {
    iconName: "swap_horiz",
    class: "",
    justifySelf: undefined,
  };

  const activeClass = isMobile ? mobileClasses : desktopClasses;
  const switchA11yText = formatText(gtConfig.switchLocKey);

  const actionSwapA11yText = formatText(gtConfig.switchActionLocKey);

  const [switchState, setSwitchState] = React.useState(false);

  const onSwapLocations = () => {
    const liveAnnounceText = switchState ? actionSwapA11yText : `${actionSwapA11yText}.`;
    liveAnnounce(liveAnnounceText, Level.ASSERTIVE);
    setSwitchState(!switchState);
    onSwapTypeheadLocations();
  };

  return (
    <UitkLayoutGridItem colSpan={colSpan} justifySelf={activeClass.justifySelf}>
      <UitkLayoutFlex alignItems="center" justifyContent="center">
        <button
          onClick={onSwapLocations}
          type="button"
          data-testid={activeClass.iconName}
          className={activeClass.class}
          aria-label={switchA11yText}
        >
          <UitkIcon id="swap-location" name={activeClass.iconName} size={UitkIconSize.MEDIUM} className="iconColor" />
        </button>
      </UitkLayoutFlex>
    </UitkLayoutGridItem>
  );
};
